import { Button } from "@appComponents/Button";
import { RestrictedContainer } from "@appComponents/RestrictedContainer/RestrictedContainer";
import React from "react";

export const Tier1Restriction = () => {
  return (
    <RestrictedContainer>
      <div className="text-center">
        <h3 className="font-normal">
          You need to complete Tier 1 to add a bank account.
        </h3>
        <h4>
          Please verify your identity and finish the Tier 1 assessment on BFID.
        </h4>

        <Button
          className="inline-block mt-4"
          isPrimary
          href="/redirect_to_identity"
        >
          Complete Tier 1 now
        </Button>
      </div>
    </RestrictedContainer>
  );
};
